import { UserGroupIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

export type {
  FeatureCrudPermissions,
  FeatureMetadata,
  FeatureNavigationMeta,
  FeatureRouteMeta,
} from "../../feature.types";

import type { FeatureMetadata } from "../../feature.types";

export const StudentsFeature: FeatureMetadata = {
  id: "students",
  moduleName: "academics",
  // guardianNavigation: {
  //   label: "My Children",
  //   order: 2,
  // },
  navigation: {
    label: "Students",
    path: "/students",
    icon: UserGroupIcon,
    order: 1,
  },
  route: {
    path: "/students/*",
    element: lazy(() => import("./pages/Students")),
  },
  permissions: {
    view: "Academics.Students.view",
    create: "Academics.Students.create",
    edit: "Academics.Students.edit",
    delete: "Academics.Students.delete",
  },
  readiness: "live",
};
